import { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import api from "@/lib/api";
import { AlertTriangle } from "lucide-react";

export const DncBypassBanner = () => {
  const [s, setS] = useState(null);
  const { pathname } = useLocation();
  useEffect(() => {
    const load = () => { api.get("/admin/dnc-bypass").then((r) => setS(r.data)).catch(() => {}); };
    load();
    window.addEventListener("dnc-bypass-changed", load);
    return () => { window.removeEventListener("dnc-bypass-changed", load); };
  }, [pathname]);
  if (!s || !(s.mortgage || s.surety)) return null;
  const sides = [s.mortgage && "Mortgage (MLO)", s.surety && "Surety bond"].filter(Boolean).join(" and ");
  return (
    <div className="mb-5 flex flex-wrap items-center gap-3 rounded-lg border border-red-700 bg-red-600 px-4 py-3 text-sm text-white shadow" role="alert" data-testid="dnc-bypass-banner">
      <AlertTriangle className="h-5 w-5 shrink-0" />
      <span className="flex-1"><b>DNC scrubbing is bypassed</b> for {sides} accounts. New numbers are not checked against Do-Not-Call or litigator lists.</span>
      <Link to="/admin/settings" className="rounded-md bg-white px-3 py-1.5 font-semibold text-red-700 hover:bg-red-50" data-testid="dnc-bypass-banner-link">Turn off</Link>
    </div>
  );
};
